import axios from "axios";
import {
  isPossiblePhoneNumber,
  isValidPhoneNumber,
} from "react-phone-number-input";
import { MilesAlert } from "@/lib/alerts";
import { QueryParams } from "@/types/forms";

export const MILES_CITIES: string[] = [
  "AHMEDABAD",
  "BANGALORE",
  "CHENNAI",
  "DELHI",
  "ERNAKULAM",
  "KOLKATA",
  "HYDERABAD",
  "MUMBAI",
  "PUNE",
  "INTERNATIONAL",
];

export const validationCheck = async (...args: any) => {
  const validRegex = (email: string) => {
    if (email.endsWith("@mileseducation.com")) {
      return /^\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
    }
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
  };

  const validPhone = /^[0-9]{10,15}$/;

  let emailError = false,
    phoneError = false,
    emptyError = false,
    phoneLength = true,
    phoneLen = true,
    dayValid = true;

  args[2] === "empty"
    ? (emptyError = args[0] === null || args[0] === undefined || args[0] === "")
    : args[2] === "empty_course"
      ? (emptyError =
          args[0] === null ||
          args[0] === undefined ||
          args[0] === "" ||
          args[0] === 0)
      : args[2] === "email"
        ? (emailError = !validRegex(args[0]))
        : args[2] === "phone"
          ? (phoneError = !args[0].match(validPhone))
          : args[2] === "phoneLen"
            ? (phoneLen =
                args[0].trim().length >= 10 || args[0].trim().length <= 15)
            : args[2] === "phoneLength"
              ? (phoneLength =
                  isPossiblePhoneNumber(args[0]) && isValidPhoneNumber(args[0]))
              : args[2] === "dayCheck"
                ? (dayValid = await checkValidDay(args[0]))
                : "";
  if (
    emailError ||
    phoneError ||
    emptyError ||
    !phoneLength ||
    !phoneLen ||
    !dayValid
  ) {
    MilesAlert({ text: args[1], type: "warning" });
    return false;
  }
  return true;
};

const checkValidDay = async (dateString: string) => {
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const date = new Date(dateString);
  const dayIndex = date.getDay();
  return days[dayIndex] == "Monday" || dateString.substring(0, 2) == "01"
    ? false
    : true;
};

export const getCityByPhoneNo = async (mobile: string) => {
  const API_URL = "https://website-api.mileseducation.com/getCityDetails";
  const payload = { contact: mobile };
  const response = await axios.post(API_URL, payload);
  if (response.data.status && response.data.data) {
    return response.data.data[0]?.allocated_city;
  } else {
    return "";
  }
};

export const getQueryParamsFromUrl = async () => {
  const url = window.location.href;
  const arr = url.split("?");
  let data: any = "";
  // Retrieve the existing object from localStorage (if any)
  let storedParams = JSON.parse(localStorage.getItem("seo_params") || "{}");

  let obj: QueryParams = {
    gclid: storedParams.gclid || null,
    tk: storedParams.tk || null,
    utm_source: storedParams.utm_source || null,
    utm_medium: storedParams.utm_medium || null,
    utm_campaign: storedParams.utm_campaign || null,
    adgroup: storedParams.adgroup || null,
    utm_term: storedParams.utm_term || null,
    utm_content: storedParams.utm_content || null,
  };

  if (arr?.length > 1) {
    const params = new URLSearchParams("?" + arr[1]);
    obj = {
      gclid: params.has("gclid") ? params.get("gclid") : obj.gclid,
      tk: params.has("tk") ? params.get("tk") : obj.tk,
      utm_source: params.has("utm_source")
        ? params.get("utm_source")
        : obj.utm_source,
      utm_medium: params.has("utm_medium")
        ? params.get("utm_medium")
        : obj.utm_medium,
      utm_campaign: params.has("utm_campaign")
        ? params.get("utm_campaign")
        : obj.utm_campaign,
      adgroup: params.has("adgroup") ? params.get("adgroup") : obj.adgroup,
      utm_term: params.has("utm_term") ? params.get("utm_term") : obj.utm_term,
      utm_content: params.has("utm_content")
        ? params.get("utm_content")
        : obj.utm_content,
    };
    data = obj?.tk;
  }

  // Only update localStorage if the values have actually changed
  const currentStored = JSON.stringify(storedParams);
  const newStored = JSON.stringify(obj);
  if (currentStored !== newStored) {
    localStorage.setItem("seo_params", newStored);
  }

  return data;
};

export function toPostgresTimestamp(date: any) {
  // Ensure leading zeros for single digit months, days, hours, minutes, and seconds
  const pad = (num: any) => num.toString().padStart(2, "0");

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1); // getMonth() returns 0-11
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  // Format the string as 'YYYY-MM-DD HH:MM:SS'
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export const googleTagManager = (event: string, data: any) => {
  window &&
    window?.dataLayer &&
    window.dataLayer.push({
      event: event,
      ...data,
    });
};

export const loadGoogleMapsScript = () => {
  if (typeof window === "undefined") return;
  if (!document.getElementById("google-maps")) {
    const script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyCdprboh7clHCyMddTlJK7nTm-IPl1U_Gc";
    script.id = "google-maps";
    script.async = true;
    document.head.appendChild(script);
  }
};
